module.exports = __webpack_public_path__ + "media/images/input_state_icon/magnifier-b16029da594c3fa37b7455d10b5ce45f.svg";